import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header.jsx';
import Footer from './components/Footer.jsx';
import HomePage from './pages/HomePage.jsx';
import AuthorPage from './pages/AuthorPage.jsx';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Toaster position="top-right" />
      
      <Header />
      
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/author" element={<AuthorPage />} />
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
